import {Component, Input, OnInit} from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';
import {debounceTime} from 'rxjs/operators';
import {Subject} from 'rxjs';

import {AuthUser, TokenService} from '../../../../core/auth';
import {PageRequest} from '../../../../core';
import {ProjectService} from '../../../../core/services';
import {Project, ProjectResponse, UpdateProjectSettingRequest} from '../../../../core/models';
import {BreadcrumbService} from '../../../../breadcrumb.service';
import {ProjectSidebarService} from '../../../../projectsidebar.service';

@Component({
  templateUrl: './project-admin-settings.page.html'
})
export class ProjectAdminSettingsPage implements OnInit {

  project:Project = null;
  touched:boolean = false;
  busy: boolean = true;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private projectService: ProjectService,
    private token: TokenService,
    private breadcrumbService: BreadcrumbService,
    private projectSidebarService: ProjectSidebarService
  ) {
  }

  ngOnInit() {
    this.route.parent.data.subscribe((data) => {
      if (data.project) {
        this.project = data.project;
        this.breadcrumbService.setItems([
          {label: 'projects', routerLink: ['/project', 'list']},
          {label: this.project.name},
          {label: 'admin'},
          {label: 'settings'}
        ]);
        this.projectSidebarService.setProject(this.project);

        this.busy = false;
      }
    });
  }

  saveProjectSettings() {
    let updateRequests = this.project.projectSettings.map(s => new UpdateProjectSettingRequest(s.id, s.value));
    this.projectService.updateSettings(this.project, updateRequests).subscribe(() => {
      this.busy = false;
      this.touched = false;
    });
  }

}
